import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=49e078a0&scoped=true"
import script from "./QuestionsList.vue?vue&type=script&lang=ts"
export * from "./QuestionsList.vue?vue&type=script&lang=ts"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=49e078a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e078a0",
  null
  
)

export default component.exports